import { makeStyles } from "@material-ui/core/styles";
import {
  h4Light,
  h4Medium,
  h6Medium,
  h6Regular,
  h7Regular,
} from "../../../shared/typography";
import { pointer, withOpacity } from "../../../shared/mixins";

export const useStyles = makeStyles(() => ({
  card: {
    borderRadius: 16,
    padding: 40,
    background: "#fff",
    maxWidth: 660,
    width: "100%",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    gap: 40,
  },

  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 12,
  },

  deliveryIndex: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
  },

  deliveryIndexHeader: {
    ...h4Light,
    ...withOpacity(0.8),
  },
  deliveryIndexDate: {
    ...h4Medium,
    ...withOpacity(0.8),
  },
  itemsList: {
    display: "flex",
    flexDirection: "column",
  },
  itemsListTotal: {
    ...h6Regular,
    ...withOpacity(0.4),
    marginBottom: 24,
  },
  itemRow: {
    display: "grid",
    gridTemplateColumns: "6fr 3fr 1fr",
    alignItems: "center",
    padding: "24px 0",
    borderTop: "1px dashed rgba(21, 34, 47, 0.08)",
  },
  left: {
    display: "flex",
    alignItems: "center",
    gap: 24,
  },
  image: {
    width: 56,
    height: 56,
    objectFit: "cover",
    borderRadius: 6,
  },
  name: {
    ...h6Regular,
    ...withOpacity(0.64),
  },
  center: {
    display: "flex",
    alignItems: "center",
    gap: 16,
  },
  heartIcon: {
    height: 40,
    width: 40,
  },
  basketIcon: {
    height: 40,
    width: 40,
    background: "#80BB34",
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    ...pointer,
  },
  qtyLabel: {
    ...h7Regular,
    ...withOpacity(0.4),
  },
  qty: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
  },
  qtyValue: {
    fontFamily: "Barlow",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "20px",
    lineHeight: "24px",
    color: "#15222F",
    ...withOpacity(0.64),
  },
  right: {
    justifySelf: "end",
    ...h6Medium,
    ...withOpacity(0.72),
  },
  unavailableItemsCenter: {
    justifySelf: "center",
  },
}));
